"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = create;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ = require(".");

function create(_x, _x2, _x3) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, item, idField) {
    var client, path, response, _ref2, _ref2$response;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, path = _ref.path;

            if (!item[idField]) {
              _context.next = 3;
              break;
            }

            throw new Error('id must be null - it will be automatically generated.');

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return client.post(path, (0, _extends2.default)({}, item), {
              headers: {
                Accept: _.APPLICATION_JSON,
                'Content-Type': _.APPLICATION_JSON
              }
            });

          case 6:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);

            if (!(((_ref2 = _context.t0) == null ? void 0 : (_ref2$response = _ref2.response) == null ? void 0 : _ref2$response.status) === 404)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", null);

          case 14:
            throw new Error("Failed to create object: " + JSON.stringify(item) + " with path: " + path);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _create.apply(this, arguments);
}